import React from 'react';
import PropTypes from 'prop-types';
import { SECTIONS, SECTION_BY_ID, matches } from '../registry';
import { Card } from '../SuperAdminAtoms';
import { groupBy, ItemRow } from './GroupedRows';

// One card per section that has a hit, in sidebar order, each row a live control.
const SearchResults = ({ items, query, onOpen, onClear }) => {
  const hits = items.filter(i => matches(i, query));
  if (!hits.length) {
    return (
      <div className="pl-empty">
        <div className="pl-empty__title">No settings match “{query}”</div>
        <div className="bz-muted">Try a vendor name, a key such as bugsProd, or a word like “coverage”.</div>
        <button type="button" className="bz-btn" onClick={onClear}>
          Clear search
        </button>
      </div>
    );
  }
  const order = Object.fromEntries(SECTIONS.map((s, n) => [s.id, n]));
  return groupBy(
    [...hits].sort((a, b) => order[a.section] - order[b.section]),
    'section'
  ).map(([sid, rows]) => (
    <Card
      key={sid}
      title={SECTION_BY_ID[sid].label}
      aside={
        <button type="button" className="pl-linkbtn" onClick={() => onOpen(sid)}>
          Open section
        </button>
      }
    >
      {rows.map(i => (
        <ItemRow key={i.uid} item={i} />
      ))}
    </Card>
  ));
};
SearchResults.propTypes = {
  items: PropTypes.array.isRequired,
  query: PropTypes.string.isRequired,
  onOpen: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired
};

export default SearchResults;
